import { FC, PropsWithChildren, memo, useCallback } from 'react'
import { GrClose, GrExpand } from 'react-icons/gr'
import { FilterDropdown } from './filters'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { classNames } from '@app/utils/classes'
import { twMerge } from 'tailwind-merge'

type TopFeedProps = {
  onClick(x: any): any
  open: boolean
  feedExist?: boolean
  clearFeed(): any
  small?: boolean
  hideSync?: boolean
}

export const feedTopStyle = 'visible lg:hidden'
export const feedMobileTopStyle = 'hidden lg:block'

const RecentTitle: FC<
  PropsWithChildren<{ small?: boolean; open?: boolean }>
> = ({ children, small, open }) => {
  if (small) {
    return <span className='flex-1' />
  }
  return (
    <p
      className={`${
        open ? '' : feedMobileTopStyle
      } flex-1 text-lg font-semibold`}
    >
      {children}
    </p>
  )
}

// issue feed top block
const Top = ({
  onClick,
  open,
  feedExist,
  clearFeed,
  small,
  hideSync,
  translation,
}: TopFeedProps & { translation?: string }) => {
  const { t } = useTranslation(translation || 'dashboard')

  const onOpenFeed = useCallback(() => {
    onClick && onClick(!open)
  }, [open, onClick])

  // TODO: translate
  const btnOpenTitle = !open ? 'open issue feed' : 'close issue feed'

  return (
    <div
      className={classNames(
        open
          ? 'flex place-items-center'
          : 'place-content-end lg:place-content-start',
        `flex place-items-center px-3 py-1 h-14 gap-x-5`
      )}
    >
      <RecentTitle small={small} open={open}>
        {t('recent')}
      </RecentTitle>
      {feedExist ? (
        <button
          onClick={clearFeed}
          className={twMerge(
            open ? '' : feedMobileTopStyle,
            'px-4 py-3 hover:text-red-700 rounded-2xl text-sm'
          )}
          type={'button'}
        >
          {t('clear')}
        </button>
      ) : null}
      <div className={open ? '' : feedMobileTopStyle}>
        <FilterDropdown open={open} />
      </div>
      {!hideSync ? (
        <button
          onClick={onOpenFeed}
          title={btnOpenTitle}
          className={classNames(
            open
              ? ''
              : `${feedTopStyle} shadow-xl border-2 bg-gray-300 dark:bg-gray-800 rounded-full`,
            'p-3 rounded-2xl hover:text-blue-400 hover:border-blue-400',
            feedExist && !hideSync
              ? 'text-blue-600 border-blue-600 text-xl'
              : 'border-transparent'
          )}
          type={'button'}
        >
          <>
            <span className='sr-only'>{t('dashboard-modal:close')}</span>
            {!open ? (
              <GrExpand className='grIcon' />
            ) : (
              <GrClose className='grIcon' />
            )}
          </>
        </button>
      ) : null}
    </div>
  )
}

// re-render on state change for toggling click event
export const FeedTopSection = memo(Top)
